export default `float y,s,e;
  p+=vec3(1.0);
  y=p.y*.3-.3;
  s=9.;
  for(int j=0;j++<9;p/=max(e,0.0001))
    p=mod(p-1.,2.)-1.,
    p.zx*=rotate2D(PI/4.0),
    e = dot(p,p)*(0.6+y),
    s /= max(e,0.0001);
  return e=sqrt(e)/s;
}`